import cn from 'classnames';
import React, { FC, forwardRef } from 'react';
import { LangSelect } from '../../features/lang-select/lang-select';
import { LangEnum, LangType } from '../../helpers/lang';
import { useInputLangStore } from '../../store/use-input-lang-store';
import s from './lang-input.module.css';
import { Input, InputProps } from '../../components/input/input';

export interface LangInputProps extends Omit<InputProps, 'value' | 'onChange'> {
  onChange: (value: LangType) => void;
  value?: LangType;
  showLanguageSelect?: boolean;
}

export const LangInput: FC<LangInputProps> = forwardRef<HTMLInputElement, LangInputProps>(
  (props, ref) => {
    const { onChange, value, showLanguageSelect = false, ...other } = props;

    const { language } = useInputLangStore();

    const handleChange = (e: React.FormEvent<HTMLInputElement>) => {
      const val = e.currentTarget.value;
      onChange({ ...value, [language as LangEnum]: val });
    };

    return (
      <div className={s.wrapper}>
        <Input
          className={cn(s.component, s.input, showLanguageSelect && s.padding)}
          onChange={handleChange}
          value={value?.[language as LangEnum]}
          ref={ref}
          {...other}
        />
        {showLanguageSelect && (
          <LangSelect className={s.select} triggerClassname={s.trigger} disabled={props.disabled} />
        )}
      </div>
    );
  },
);

LangInput.displayName = 'LangInput';
